export default __webpack_public_path__ + "static/media/Shawna-Teenney.5318118f.jpg";